
export const OEPresentationViewFlags = {
    none:                                   0,
    editor:                                 1,
    mediaCenter:                            2,
    std:                                    3
};

export const OEPresentationFlags = {
    none:                                   0,
    noSlider:                               1,
    animatePrevSlideTransitions:            2,
    disableStateTracking:                   4,
    noPreviewSlides:                        8,
    noBackForth:                            16,
    std:                                    0
};

export const OEPresentationPlayableFlags = {
    none:                                   0,
    multipleSlides:                         1,
    audio:                                  2,
    animatableAttribute:                    4,
    animatableSlideAttribute:               8,
    audioAnimatableAttribute:               6,
    audioAnimatableSlideAttribute:          10,
    all:                                    15
};

OEPresentationPlayableFlags.isPlayable = function(flags, animatableState, hasSlideAnimatableAttribute)   {
    return (animatableState.slideCount > 1 && !!(flags & OEPresentationPlayableFlags.multipleSlides)) ||
            (animatableState.hasAudioTrack && !!(flags & OEPresentationPlayableFlags.audio)) ||
            (animatableState.hasAnimatableAttribute && !!(flags & OEPresentationPlayableFlags.animatableAttribute)) ||
            (!!hasSlideAnimatableAttribute && !!(flags & OEPresentationPlayableFlags.animatableSlideAttribute));
};

export const OEPresentationAttrType = {
    dummy:                                  0,
    custom:                                 1,
    link:                                   2
};

export const OEPresentationAttrLinkType = {
    animation:                              0
};

export const OEPresentationDefaultAnimatableState = {
    canAnimate:                             false,
    shouldBePlayable:                       false,
    slideCount:                             0,
    previewSlideCount:                      0,
    hasAudioTrack:                          false,
    hasAnimatableAttribute:                 false
};

export const OEPresentationNoteStateModResultType = {
    ok:                                     0,
    couldNotOpenFile:                       1,
    fileCorrupt:                            2,
    unexpected:                             3,
    uiLock:                                 4,
    couldNotLoadPresentation:               5
};